import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useAnnouncements () {
  return useQuery('announcements', async () => {
    const announcements = await axios.get(`${getApiServer()}/announcements`, { withCredentials: true })
    return announcements.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}